<template>
  <div class="hello">
    <section class="sm:mt-6 lg:mt-8 mt-12 mx-auto px-4 sm:px-6 lg:px-8">
      <div
        class="my-10 mx-auto sm:px-40 sm:mt-12 md:mt-16 lg:mt-20 xl:mt-28 flex gap-3 lg:flex-justify lg:flex flex-col lg:flex-row"
      >
        <div class="sm:text-center lg:text-left">
          <h1
            class="text-4xl tracking-tight font-extrabold text-gray-800 sm:text-5xl md:text-6xl"
          >
            <span class="block xl:inline arabic-font">كلية العلوم الإسلامية بجامعة الأزهر بالقاهرة</span>
            <span class="block text-indigo-600 xl:inline arabic-font">تعليم عن بعد</span>

          </h1>
          <!-- <p
            class="mt-3 text-base text-gray-500 sm:mt-5 sm:text-lg sm:max-w-xl sm:mx-auto md:mt-5 md:text-xl lg:mx-0"
          >
            Anim auaasascte id magna aliqua ad ad non deserunt sunt. Qui irure qui
            lorem cupidatat commodo. Elit sunt amet fugiat veniam occaecat
            fugiat aliqua.
          </p> -->
          <!-- Button Section -->
          <div class="mt-5 sm:mt-8 sm:flex sm:justify-center lg:justify-start">
            <div class="rounded-md shadow">
              <a
                href="/registrasi"
                class="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-white bg-gray-800 hover:bg-gray-600 md:py-4 md:text-lg md:px-10"
              >
                Daftar Sekarang
              </a>
            </div>
            <div class="mt-3 sm:mt-0 sm:ml-3">
              <a
                href="https://aisif.id/"
                class="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-gray-800 bg-indigo-100 hover:bg-indigo-200 md:py-4 md:text-lg md:px-10"
              >
                Menuju Laman AISIF
              </a>
            </div>
          </div>
          <!-- End of Button Section -->
        </div>

        <!--   Image Section     -->
        <div class="lg:inset-y-0 lg:right-0 lg:w-1/2 my-4">
          <img
            class="h-56 w-full object-cover sm:h-72 md:h-96 lg:w-full lg:h-full"
            src="https://images.unsplash.com/photo-1551434678-e076c223a692?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2850&q=80"
            alt=""
          />
        </div>
        <!--   End of Image Section     -->
      </div>
    </section>

  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  props: {
    msg: String,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.arabic-font {
  font-family: 'Tajawal', sans-serif;
}

.philosopher-bold {
  font-family: "Philosopher", sans-serif;
  font-weight: 700;
  font-style: normal;
}


h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
